import React from "react";
import { NormalButton } from "../NormalButton/NormalButton";
interface CancelButtonProps extends Omit<React.HTMLAttributes<HTMLButtonElement>, "onClick" | "children" | "color"> {
  size?: "large" | "small" | "medium";
  onClick?: () => void;
  children: string;
}

export function CancelButton({ size = "large", onClick, children, ...props }: CancelButtonProps) {
  return (
    <NormalButton size={size} variant="secondary" onClick={onClick} color="greyscale600" {...props}>
      {children}
    </NormalButton>
  );
}
